import { OVERLAY_TOP_BAR } from "@/components/navigations/BackButton"
import { ExpandingSearch } from "@/components/search/ExpandingSearch"
import { CHROME_Z_INDEX } from "@/contexts/ModalContext"
import { CHROME_BAR, Text } from "@/components/ui"
import { cn } from "@/lib/cn"

export const HeaderSticky = ({
  scrollYPosition,
  name,
  reactComponent,
  itemsFilter,
  setItemsFilter,
  showIconSearch = true,
  showSearch,
  setShowSearch,
}: {
  scrollYPosition: number,
  name: string,
  reactComponent: React.ReactNode,
  itemsFilter: string,
  setItemsFilter: (value: string) => void,
  showIconSearch?: boolean,
  showSearch: boolean,
  setShowSearch: (value: boolean) => void,
}) => {
  return (
    <div style={{ zIndex: CHROME_Z_INDEX.header }} className={cn(
      OVERLAY_TOP_BAR,
      "transition-[background-color,box-shadow] duration-slow ease-standard",
      scrollYPosition > 200
        ? cn(CHROME_BAR, "ring-1 ring-card/30")
        : "bg-transparent"
    )}>
      {reactComponent}

      <div className={cn(
        "min-w-0 flex-1 transition-[opacity,transform] duration-slow ease-standard",
        scrollYPosition > 200 && !showSearch
          ? "opacity-100 translate-x-0"
          : "opacity-0 translate-x-4 pointer-events-none"
      )}>
        <Text aria-hidden size="2xl" weight="bold" tone="default" truncate>
          {name}
        </Text>
      </div>

      {showIconSearch && (
        <ExpandingSearch
          open={showSearch}
          onOpenChange={setShowSearch}
          value={itemsFilter}
          onValueChange={setItemsFilter}
          className="max-w-lg"
        />
      )}
    </div>
  )
}
